import { G } from "@mobily/ts-belt";

export function ensureDefined<T>(
	value: T | undefined,
	errorMessage: string,
): T {
	if (value === undefined) {
		throw new Error(errorMessage);
	}
	return value;
}

export function ensureNotNull<T>(value: T | null, errorMessage: string): T {
	if (value === null) {
		throw new Error(errorMessage);
	}
	return value;
}

export function typedValues<T extends object>(obj: T): Array<T[keyof T]> {
	return Object.values(obj) as Array<T[keyof T]>;
}

export function typedKeys<T extends object>(obj: T): Array<keyof T> {
	return Object.keys(obj) as Array<keyof T>;
}

/**
 * Check value is not null
 *
 * @param value
 * @returns type predicate value is not null
 */
export function isNotNull<T>(value: T): value is Exclude<T, null> {
	return G.isNot(G.isNull)(value);
}

export type NonEmptyArray<T> = [T, ...T[]] & T[];

/**
 * Check array is not empty
 *
 * @param array
 * @returns type predicate array is not empty
 */
export function hasItems<T>(
	array: ReadonlyArray<T>,
): array is NonEmptyArray<T> {
	return array.length > 0;
}
